import { generateTable } from '../../../ui/table/index.js';

export { handleObjectDisplay };

/**
 * Handles the display of an object in the plot window.
 *
 * @memberof vef.data.dasf
 * 
 * @param {string|Object} data - The data to be displayed. It can be either a string or an object.
 * @param {Object} plotWindow - The plot window object where the data will be displayed.
 */
function handleObjectDisplay(data, plotWindow) {

    if (typeof data === 'string' || data instanceof String) {
        plotWindow.setContent(data)
    } else {
        let container = generateTable(data);
        plotWindow.setContent(container.outerHTML);
    }

}